import axios from "axios";

// If REACT_APP_BACKEND_URL is set (preview / explicit cross-origin),
// hit `${URL}/api/*` directly. If empty/undefined (production same-origin
// deployment where `/api/*` is proxied to the backend on the same domain),
// use a relative `/api` so the browser never triggers a CORS preflight.
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ashra_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // do nothing here; route guards handle
    }
    return Promise.reject(err);
  }
);
